export const mutations = {
  STORE_TARRIFS(state, tarrifs) {
    state.tarrifs = tarrifs;
  },
  STORE_TARRIF_UPDATE(state, tarrifId) {
    let Tarrif = state.tarrifs.find(function(tarrif) {
      return tarrif.id === tarrifId;
    });
    state.systemTarrif = Tarrif;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/tarrifs/mutations.js